import { Download } from '@mui/icons-material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { GetFileSize, DisplayDateTime } from '../../../../../utils/formats';

interface MUIDownloadFileProps {
	fileMetaData: any;
	onDownload: () => {};
	downloadedOn: string;
	readonly?: boolean;
	disabled?: boolean;
	multipleFiles?: boolean;
	showDownloadedOn?: boolean;
	showDownloadButton?: boolean;
}

const MUIDownloadFile: FC<MUIDownloadFileProps> = ({
	fileMetaData,
	onDownload,
	downloadedOn,
	disabled = false,
	readonly = false,
	multipleFiles = false,
	showDownloadedOn = true,
	showDownloadButton = true,
}) => {
	console.log('disabled', disabled, 'readOnly', readonly);

	return (
		<>
			<TableContainer sx={{ overflow: 'initial' }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Dateiname</TableCell>
							<TableCell align="right">Dateigröße</TableCell>
							{showDownloadedOn && <TableCell align="right">Heruntergeladen am</TableCell>}
							<TableCell align="right">Aktion</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{multipleFiles ? (
							<>
								{(Array.isArray(fileMetaData) ? fileMetaData : []).map((eachFile, i) => (
									<TableRow key={i}>
										<TableCell>{get(eachFile, 'attributes.name')}</TableCell>
										<TableCell align="right">
											{GetFileSize(get(eachFile, 'attributes.size') / (get(eachFile, 'id') ? 1 : 1000))}
										</TableCell>
										{showDownloadedOn && <TableCell align="right">{DisplayDateTime(downloadedOn)}</TableCell>}
										<TableCell align="right">
											{showDownloadButton && get(eachFile, 'attributes.url', '') && (
												<IconButton
													onClick={() => {
														onDownload();
													}}
												>
													<Download />
												</IconButton>
											)}
										</TableCell>
									</TableRow>
								))}
							</>
						) : (
							<>
								<TableRow>
									<TableCell>{get(fileMetaData, 'attributes.name')}</TableCell>
									<TableCell align="right">
										{GetFileSize(get(fileMetaData, 'attributes.size') / (get(fileMetaData, 'id') ? 1 : 1000))}
									</TableCell>
									{showDownloadedOn && <TableCell align="right">{DisplayDateTime(downloadedOn)}</TableCell>}
									<TableCell align="right">
										{showDownloadButton && get(fileMetaData, 'attributes.url', '') && (
											<IconButton
												onClick={() => {
													if (typeof onDownload === 'function') {
														onDownload();
													}
												}}
											>
												<Download />
											</IconButton>
										)}
									</TableCell>
								</TableRow>
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
export default MUIDownloadFile;
